import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_SINGLE_REQUEST,
    GET_USER_REQUEST_COUNT,
} from './returnTypes'
export default (state, action) => {
    switch (action.type) {
        case GET_SINGLE_REQUEST:
            return {
                ...state,
                single_request: action.payload,
            }
        case GET_USER_REQUEST_COUNT:
            return {
                ...state,
                user_request_count: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
